import { render, staticRenderFns } from "./Mapping.vue?vue&type=template&id=4f6c7b54&scoped=true&"
import script from "./Mapping.vue?vue&type=script&lang=js&"
export * from "./Mapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c7b54",
  null
  
)

export default component.exports